if (!customElements.get('offer-actions')) {
  customElements.define(
    'offer-actions',
    class OfferActions extends HTMLElement {
      constructor() {
        super();
        this.btn = this.querySelector('#add-to-cart');
        this.buyOnceBtn = this.querySelector('#buy-once');
        this.upsellSelected = this.dataset.isUpsellSelected === 'true';
        this.ctaSellingPlan = this.dataset.ctaSellingPlan;
        this.ctaSellingPlanUpsell = this.dataset.ctaSellingPlanUpsell;
        this.ctaOneTime = this.dataset.ctaOneTime;
        this.ctaOneTimeUpsell = this.dataset.ctaOneTimeUpsell;
        this.isOneTimePurchase = false;
        this.btnIconHtml = this.btn?.querySelector('svg')?.outerHTML || '';
        this.handleSubmitOfferBound = this.handleSubmitOffer.bind(this);
        this.handleSubmitOneTimeBound = this.handleSubmitOneTime.bind(this);
        this.handleProductSelectedBound = this.handleProductSelected.bind(this);
        this.handleUpsellSelectedBound = this.handleUpsellSelected.bind(this);

        if (this.btn) {
          this.btn.addEventListener('click', this.handleSubmitOfferBound);
        }
        if (this.buyOnceBtn) {
          this.buyOnceBtn.addEventListener('click', this.handleSubmitOneTimeBound);
        }

        document.addEventListener('product-selected', this.handleProductSelectedBound);
        document.addEventListener('upsell-selected', this.handleUpsellSelectedBound);
      }

      disconnectedCallback() {
        if (this.btn) {
          this.btn.removeEventListener('click', this.handleSubmitOfferBound);
        }
        if (this.buyOnceBtn) {
          this.buyOnceBtn.removeEventListener('click', this.handleSubmitOneTimeBound);
        }
        document.removeEventListener('product-selected', this.handleProductSelectedBound);
        document.removeEventListener('upsell-selected', this.handleUpsellSelectedBound);
      }

      handleSubmitOffer(event) {
        event.preventDefault();
        this.dispatchEvent(
          new CustomEvent(this.isOneTimePurchase ? 'submit-one-time' : 'submit-offer', {
            bubbles: true,
          }),
        );
      }

      handleSubmitOneTime(event) {
        event.preventDefault();
        this.dispatchEvent(
          new CustomEvent('submit-one-time', {
            bubbles: true,
          }),
        );
      }

      getCurrentLabels() {
        return {
          sellingPlan: this.upsellSelected ? this.ctaSellingPlanUpsell : this.ctaSellingPlan,
          buyOnce: this.upsellSelected ? this.ctaOneTimeUpsell : this.ctaOneTime,
        };
      }

      getEventSectionId(event) {
        const targetElement = event.target instanceof Element ? event.target : null;
        return targetElement?.closest('offer-section')?.dataset.sectionId;
      }

      handleUpsellSelected(event) {
        const eventSectionId = this.getEventSectionId(event);
        if (eventSectionId !== this.dataset.sectionId) return;

        this.upsellSelected = event.detail.upsellSelected;
        const labels = this.getCurrentLabels();
        this.displayLabel(labels.sellingPlan, labels.buyOnce, this.isOneTimePurchase);
      }

      handleProductSelected(event) {
        // Only handle events from multi-product-blocks within this section
        const eventSectionId = this.getEventSectionId(event);
        if (eventSectionId !== this.dataset.sectionId) return;

        const { sellingPlanId, ctaSellingPlan, ctaSellingPlanUpsell, ctaOneTime, ctaOneTimeUpsell, upsellProductId } =
          event.detail;

        this.ctaSellingPlan = ctaSellingPlan;
        this.ctaSellingPlanUpsell = ctaSellingPlanUpsell;
        this.ctaOneTime = ctaOneTime;
        this.ctaOneTimeUpsell = ctaOneTimeUpsell;
        this.isOneTimePurchase = sellingPlanId === '' || sellingPlanId === undefined;

        if (!upsellProductId) {
          this.upsellSelected = false;
        }

        const labels = this.getCurrentLabels();
        this.displayLabel(labels.sellingPlan, labels.buyOnce, this.isOneTimePurchase);
      }

      displayLabel(labelSellingPlan, labelBuyOnce, isOneTimePurchase) {
        console.log('Displaying labels:', { labelSellingPlan, labelBuyOnce, isOneTimePurchase });
        const setMainButtonLabel = (label) => {
          if (!this.btn) return;
          this.btn.innerHTML = label || '';
          if (this.btnIconHtml) {
            this.btn.insertAdjacentHTML('beforeend', this.btnIconHtml);
          }
        };

        if (this.buyOnceBtn) {
          this.buyOnceBtn.innerHTML = labelBuyOnce || '';
        }

        if (!isOneTimePurchase) {
          setMainButtonLabel(labelSellingPlan);
          return;
        }

        setMainButtonLabel(labelBuyOnce);
      }
    },
  );
}
